export default defineNuxtRouteMiddleware((to, from) => {
  if (to.fullPath === '/malkurs-gutschein/konfigurator') {
    return navigateTo("/malkurs-gutschein/gutscheinkarte-kaufen");
  }

});